/**
 * @license
 * Copyright (c) 2021-present, FriendliAI Inc. All rights reserved.
 */

import * as React from 'react';
import type { SVGProps } from 'react';
const SvgColoredGoogle = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 20 20"
    {...props}
  >
    <path fill="#fff" d="M0 0h20v19.999H0z" />
    <path
      fill="#FBBB00"
      d="m4.433 12.087-.697 2.598-2.544.054A9.955 9.955 0 0 1 0 10a9.95 9.95 0 0 1 1.118-4.599l2.266.416.992 2.251A5.944 5.944 0 0 0 4.056 10c0 .734.133 1.438.377 2.087Z"
    />
    <path
      fill="#518EF8"
      d="M19.825 8.132a10.02 10.02 0 0 1-.044 3.956 9.997 9.997 0 0 1-3.52 5.71h-.001l-2.854-.145-.403-2.521a5.96 5.96 0 0 0 2.564-3.044H10.22V8.132h9.605Z"
    />
    <path
      fill="#28B446"
      d="M16.261 17.798A9.958 9.958 0 0 1 10.002 20a9.999 9.999 0 0 1-8.808-5.261l3.24-2.653a5.946 5.946 0 0 0 8.571 3.045l3.257 2.667Z"
    />
    <path
      fill="#F14336"
      d="m16.383 2.302-3.24 2.652a5.948 5.948 0 0 0-8.767 3.114L1.118 5.401A9.998 9.998 0 0 1 10 0c2.426 0 4.65.864 6.383 2.302Z"
    />
  </svg>
);

export default SvgColoredGoogle;
